var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v2_popover_container"},[(_vm.visible)?_c('div',{staticClass:"v2_popover_backdrop",on:{"click":_vm.closePopover}}):_vm._e(),(_vm.visible)?_c('div',{staticClass:"v2_popover"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }